import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { VerifyCustomerService } from '../verify-customer.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'logzy-lead-table',
    templateUrl: './lead-table.component.html',
    styleUrls: ['./lead-table.component.scss']
})
export class LeadTableComponent implements OnInit {
    updateUserAndLeadList: boolean = false;
    searchTerm = '';
    searchText = new BehaviorSubject<string>('');
    // approvalStatus = { "value": "pending", "label": "Pending" };

    userAndLeadList;
    verifyModelService: VerifyCustomerService

    leadPageLength = 0;
    leadPageSize = 10;
    leadPageIndex = 0;
    loading: boolean = true;
    displayColumns = ['transaction_type_display', 'lead_id', 'name', 'company', 'equipment', 'created_at', 'pol_list', 'pod_list', 'lead']
    // 'company_address','pod_list' has been removed as not required
    baseApiUrl = environment.baseApiUrl;
    status = [
        { "value": "pending", "label": "Pending" },
        { "value": "approved", "label": "Approved" },
        { "value": "rejected", "label": "Rejected" },
        { "value": "under_process", "label": "In Process" },
        { "value": "", "label": "All" }

    ]

    filter_nature = [
        { "value": "new", "label": "New Registration" },
        { "value": "one_way", "label": "OneWay" },
        { "value": "lease", "label": "Lease" },
        { "value": "buy_sell", "label": "Trade" },
    ]
    constructor(private router: Router,
        public verifyCustomerService: VerifyCustomerService,
    ) { }

    ngOnInit(): void {
        // this.getBrowserLocation();
        this.resetComponent();
    }

    resetComponent() {
        this.verifyModelService = this.verifyCustomerService;

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                if (searchText == '') {
                    this.getUserAndLeadList();
                } else {
                    this.getUserAndLeadList(searchText, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature, this.leadPageSize, this.leadPageIndex)
                }
            })
        ).subscribe();
    }

    filterByApprovalStatus(event) {
        if (this.verifyCustomerService.approvalStatus != event) {
            this.searchTerm = null;
        }
        this.updateUserAndLeadList = true;
        this.getUserAndLeadList(null, event,null, null, null, ``);
        this.verifyCustomerService.approvalStatus = event;
        console.log("approvalStatus",this.verifyCustomerService.approvalStatus)
    }

    filterByNature(event) {
        if (this.verifyCustomerService.nature != event) {
            this.searchTerm = null;
        }
        this.updateUserAndLeadList = true;
        this.getUserAndLeadList(null, null,event, null, null, ``);
        this.verifyCustomerService.nature = event;
        console.log("approvalStatus",this.verifyCustomerService.nature)
    }

    applyFilter(event) {
        this.searchTerm = event;
        this.updateUserAndLeadList = true;
        this.searchText.next(event);
    }

    announceSortChange(sortState: Sort) {
        this.updateUserAndLeadList = true;
        switch (sortState.direction) {
            case 'asc':
                if (sortState.active == 'name') {
                    this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature, this.leadPageSize, this.leadPageIndex, `first_${sortState.active}`);
                } else {
                    this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature, this.leadPageSize, this.leadPageIndex, sortState.active);
                }
                break;

            case 'desc':
                if (sortState.active == 'name') {
                    this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature, this.leadPageSize, this.leadPageIndex, `-first_${sortState.active}`);
                } else {
                    this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus, this.verifyCustomerService.nature,this.leadPageSize, this.leadPageIndex, `-${sortState.active}`);
                }
                break;

            default:
                this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature, this.leadPageSize, this.leadPageIndex, null);
        }
    }

    pageChanged(event: PageEvent) {
        this.updateUserAndLeadList = true;
        this.leadPageSize = event.pageSize;
        this.leadPageIndex = event.pageIndex;
        this.getUserAndLeadList(this.searchTerm, this.verifyCustomerService.approvalStatus,this.verifyCustomerService.nature)
    }

    view(leadData) {
        if (leadData.leads.length) {
            this.router.navigateByUrl(`/verify-customer/leads?id=${leadData.leads[0].id}`);
        } else {
            this.router.navigateByUrl(`/verify-customer/users?id=${leadData.id}`);
        }
    }

    getUserAndLeadList(searchTerm = null, approval_status = null,nature=null, pageSize = null, pageIndex = null, ordering = '') {
        pageSize = pageSize || this.leadPageSize;
        pageIndex = pageIndex || this.leadPageIndex;
        approval_status = approval_status || this.verifyCustomerService.approvalStatus;
        nature = nature || this.verifyCustomerService.nature;


        this.verifyCustomerService.getUsers(searchTerm, approval_status.value,nature?.value, pageSize, pageIndex + 1, ordering).subscribe({
            next: res => {
                this.userAndLeadList = new MatTableDataSource(res.results)
                // console.log(this.userAndLeadList);
                this.leadPageLength = res.count;
                this.loading = false;
                this.updateUserAndLeadList = false;
            },
            error: err => {
                console.log(err);
            }
        });
    }

    // getBrowserLocation() {
    //     console.log('location', navigator.geolocation);
    //     let currLat = null
    //     let currLng = null
    //     if (navigator.geolocation) {
    //         navigator.geolocation.getCurrentPosition(position => {
    //             console.log('position', position);

    //             currLat = position.coords.latitude;
    //             currLng = position.coords.longitude;
    //             console.log('lat long', currLat, currLng);
    //         });
    //     }
    //     else {
    //         alert("Geolocation is not supported by this browser.");
    //     }
    //     console.log('location', currLat, currLng);
    // }
    createLead() {
        this.router.navigateByUrl(`/create-leads`);
    }

    backToDashboard() {
        this.router.navigateByUrl(`dashboards/dashboard1`);
    }
    getLeadStatus(status: string): string {
        switch (status) {
            case 'pending':
                return 'Pending';
            case 'under_process':
                return 'In Process';
            case 'rejected':
                return 'Rejected';
            case 'approved':
                return 'Approved'
            default:
                return;
        }
    }
}
